// extracted by mini-css-extract-plugin
module.exports = {"container":"SkipLinks_container__4n2qY"};